import React from 'react';

interface Props {
  status: string;
  isToday: boolean;
}

const GateScheduleTableRowCell: React.FC<Props> = (props) => {
  const { status, isToday } = props;

  return (
    <div className={`gate-schedule-table-body-row-cell${isToday ? ' today' : ''}`}>
      <div className={`gate-schedule-table-body-row-cell-content${status ? ` ${status}` : ''}`}>
        {status}
      </div>
    </div>
  );
};
GateScheduleTableRowCell.displayName = 'GateSchedule.TableRowCell';

export default GateScheduleTableRowCell;
